import styled from "styled-components";
import zIndexTypes from "../../../../theme/zIndexTypes";
import {
  mediaMaxWidth,
  mediaMinWidth,
} from "../../../utils/mediaQueriesTemplate";

export const ModalWrapper = styled.div``;

export const ModalButton = styled.button`
  font-weight: bold;
  color: #fff;
  background: #f2008c;
  border: 1px solid #f2008c;
  box-sizing: border-box;
  border-radius: 4px;
  line-height: 22px;
  text-rendering: optimizeLegibility;
  padding: 12px;
  font-family: Raleway;
  text-align: center;
  letter-spacing: 0.03em;
  text-transform: capitalize;
  font-size: 1.188em;
  min-width: 100px;
  transition: 0.15s ease-in-out;

  &:focus {
    outline: none;
  }
`;

export const ModalBackDrop = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  width: 0;
  height: 0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${zIndexTypes.modal};
  opacity: 0;

  &.active {
    opacity: 1;
    transition: 0.15s opacity;
    width: 100vw;
    height: 100vh;
  }
`;

export const ModalContent = styled.div`
  background-color: #f4f4f4;
  margin: 15px auto;
  width: 70%;
  box-shadow: 0 0 5px rgb(136, 136, 136);
  border-radius: 4px;
  padding: 0;
  right: -100vw;
  transition: 0.25s ease-in-out;
  position: fixed;
  top: 0;
  width: 70vw;
  overflow: hidden;

  &.active {
    left: 0;
    right: 0;
    z-index: 7;
  }

  canvas {
    width: 100% !important;
  }

  ${mediaMinWidth.desktop`
    width: 50vw;
  `}

  ${mediaMaxWidth.tablet`
    width: calc(100vw - 10px);
    height: ${(props) =>
      props.iOS ? "calc(100vh - 85px)" : "calc(100vh - 10px)"};
    margin: 5px auto;
  `}
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  text-align: center;

  &:hover {
    background-color: #f2008c;
  }
`;

export const ModalTitle = styled.div`
  flex: 1;
  font-size: 1.3em;
  font-weight: 500;
`;

export const ModalCloseButton = styled.div`
  position: absolute;
  z-index: 1;
  right: 11px;
  font-size: 1.4em;
  top: 12px;
  background-color: #673490;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  cursor: pointer;
  transition: 0.1s ease-in-out;

  &:hover {
    background-color: #f2008c;
  }
`;

export const ModalBody = styled.div`
  margin: 0;
  overflow: scroll;
  height: calc(100vh - 25px);

  ${mediaMaxWidth.tablet`
    height: calc(100vh - 55px);
    overflow-x: hidden;
  `}
`;

export const ModalFooter = styled.div`
  text-align: center;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 60px;
  background: #e4e5e7;

  &.hideFooter {
    height: 0;
  }
`;
